<div class="menu__head">
  <span class="menu__logo" style="background-color:#F5F5F5;">
    <img src="../../../../assets/images/FindTheLost_Logo.png" alt="Powered by NPS"/>
  </span>
  <mzima-client-button
    *ngIf="!isDesktop"
    fill="outline"
    color="custom"
    [iconOnly]="true"
    class="menu__head__close"
    (buttonClick)="toggleBurgerMenu(false)"
    [ariaLabel]="'modal.button.close' | translate"
  >
    <mat-icon icon svgIcon="close"></mat-icon>
  </mzima-client-button>
</div>
<app-company-info *ngIf="checkAllowedAccessToSite()"></app-company-info>
